import { useEventDetailsContext } from '../../contexts/RingContext';

const useVenueRoute = route => {
    const { isEventWhiteLabel, whitelabelPath } = useEventDetailsContext();

    if (isEventWhiteLabel) {
        return (whitelabelPath ?? '') + '/venue' + route;
    }

    const baseRoute = '/:eventUniqueName';
    return baseRoute + route;
};

export default useVenueRoute;
